import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";

import { AccountResponse } from "../../interfaces/account-response.interface";
import { Logon } from "../../interfaces/logon.interface";
import { IUserAccountUpdatePayload } from "../../interfaces/payload-update-user-account.interface";
import { User } from "../../interfaces/user.interface";
import { ResetUser } from "../../interfaces/reset-user.interface";
import { CloneLogonSearchResponse } from "../../interfaces/cloneable-logon-search.interface";
import {
  CloneLogonRequest,
  CloneLogonResponse,
} from "../../interfaces/clone-logon.interface";
import { UserMe } from "@serasa/core/modules/recertification/interfaces/user-me.interface";
import { IMyAudit } from "@serasa/core/pages/actions-history/models/deleted-user.interface";

export const loadManagerProfileSuccess = createAction(
  "[User] Load Manager Profile Success",
  props<{ userManager: Logon }>(),
);

export const loadLogonsList = createAction(
  "[User] Load Users",
  props<{ offset?: number; limit?: number; isPagination: boolean }>(),
);

export const loadLogonsListSuccess = createAction(
  "[User] Load Logons List Success",
  props<{ accountResponse: AccountResponse; showEmptyList?: boolean }>(),
);

export const loadSearchSuccess = createAction(
  "[User] Load Search Success",
  props<{
    accountResponse: AccountResponse;
    showEmptyList?: boolean;
  }>(),
);

export const loadSelectedLogon = createAction(
  "[User] Load Selected Logon",
  props<{ selectedUserId: string; userDataTable: Partial<User> }>(),
);

export const loadSelectedLogonSuccess = createAction(
  "[User] Load Selected Logon Success",
  props<{ selectedLogon: Logon }>(),
);

export const loadUpdateSelectedLogonSuccess = createAction(
  "[User] Load Update Selected Logon Success",
  props<{ payload: IUserAccountUpdatePayload }>(),
);

export const loadUpdateAccountResponseFailure = createAction(
  "[User] Update Account Failure",
  props<{ error: HttpErrorResponse }>(),
);

export const loadResetUpdateAccountFailure = createAction(
  "[User] Reset Update Account Failure",
);

export const loadSelectedLogonFailure = createAction(
  "[User] Load Selected Logon Failure",
  props<{ error: HttpErrorResponse }>(),
);

export const loadAccountResponseFailure = createAction(
  "[User] Load Logons Failure",
  props<{ error: HttpErrorResponse }>(),
);

export const updateSelectedLogon = createAction(
  "[User] Update Selected Logon",
  props<{
    logon: string;
    userId: string;
    payload: IUserAccountUpdatePayload;
  }>(),
);

export const doTablePagination = createAction(
  "[Table] Do Pagination",
  props<{ accountResponse: AccountResponse }>(),
);

export const setEmptyData = createAction("[Table] Set Empty Data");

export const filterByLogon = createAction(
  "[User] Filter by Logon",
  props<{ logon: string }>(),
);

export const loadResetUser = createAction("[User] Load Reset User");
export const loadResetSelectedUser = createAction(
  "[User] Load Reset Selected User",
);

export const closeSideNav = createAction("[SideNav] Close");

export const loadToggleSidenav = createAction(
  "[Sidenav] Toggle Sidenav",
  props<{ openSidenav: boolean }>(),
);

// ----- Reset User

export const resetUser = createAction(
  "[User] Reset User",
  props<{ resetUser: ResetUser }>(),
);

export const resetUserSuccess = createAction(
  "[User] Reset User Success",
  props<{ resetStatus: string }>(),
);

export const resetUserFailure = createAction(
  "[User] Reset User Failure",
  props<{ error: HttpErrorResponse; resetStatus?: string }>(),
);

// ----- Clone Logon

export const loadCloneableLogonSearchData = createAction(
  "[User] Load Cloneable Logon Data",
  props<{ logon: string }>(),
);

export const loadCloneableLogonSearchDataSuccess = createAction(
  "[User] Load Cloneable Logon Data Success",
  props<{ cloneableLogon: CloneLogonSearchResponse }>(),
);

export const loadCloneableLogonSearchDataFailure = createAction(
  "[User] Load Cloneable Logon Data Failure",
  props<{ error: HttpErrorResponse }>(),
);

export const addClonedUser = createAction(
  "[User] Add Cloned User",
  props<{ payload: CloneLogonRequest }>(),
);

export const addClonedUserSuccess = createAction(
  "[User] Add Cloned User Success",
  props<{ response: CloneLogonResponse }>(),
);

export const addClonedUserFailure = createAction(
  "[User] Add Cloned User Failure",
  props<{ error: HttpErrorResponse }>(),
);

// ----- User Me Info

export const loadUserMeInfo = createAction("[User] Load User Me Info");

export const loadUserMeInfoSuccess = createAction(
  "[User] Load User Me Info Success",
  props<{ userMeInfo: UserMe }>(),
);

export const loadUserMeInfoFailure = createAction(
  "[User] Load User Me Info Failure",
  props<{ error: HttpErrorResponse }>(),
);

export const cleanClonedUser = createAction("[User] Clean Cloned User");

// ----- My Audits 

export const loadMyAudits = createAction(
  "[User] Load My Audits",
  props<{ params?: Map<string, string> }>(),
);

export const loadResetMyAudits = createAction(
  "[User] Load Reset My Audits"
);

export const loadMyAuditsSuccess = createAction(
  "[User] Load My Audits Success",
  props<{ myAudits: IMyAudit }>(),
);

export const loadMyAuditsFailure = createAction(
  "[User] Load My Audits Failure",
  props<{ error: HttpErrorResponse | null }>(),
);
